export default "__VITE_ASSET__DjBTaHrq__"